import { SparkelloUser } from 'sparkello-core';
import { User } from 'firebase/app';

export interface UserProps {
  bio?: string;
  location?: string;
  website?: string;
  profilePhotoUrl?: string;
  displayName?: string;
}

export class SparkelloWebUser implements SparkelloUser<User> {

  firebaseUser: User;
  bio?: string;
  location?: string;
  website?: string;
  profilePhotoUrl?: string;
  displayName?: string;

  constructor(user: User, props?: UserProps) {
    this.firebaseUser = user;
    this.bio = props?.bio;
    this.location = props?.location;
    this.website = props?.website;
    this.profilePhotoUrl = props?.profilePhotoUrl;
    this.displayName = props?.displayName || this.firebaseUser.displayName || '';
  }

  get uid(): string {
    return this.firebaseUser.uid;
  }

  get email(): string {
    return this.firebaseUser.email || '';
  }

  get emailVerified(): boolean {
    return this.firebaseUser.emailVerified;
  }

  get photoUrl(): string | undefined {
    return this?.profilePhotoUrl || (this?.firebaseUser?.photoURL ? this?.firebaseUser?.photoURL : undefined);
  }

  set photoUrl(url: string | undefined) {
    this.profilePhotoUrl = url ? url : undefined;
  }

  get socialPhotoUrl(): string | null {
    return this.firebaseUser.photoURL;
  }
}
